import { render } from "./ProviderQuestionsSection.vue?vue&type=template&id=409854e0&scoped=true"
import script from "./ProviderQuestionsSection.vue?vue&type=script&lang=js"
export * from "./ProviderQuestionsSection.vue?vue&type=script&lang=js"

import "./ProviderQuestionsSection.vue?vue&type=style&index=0&id=409854e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409854e0"]])

export default __exports__